<script>
export default {
    name: "circle-first",
};
</script>
<template>

    <div class="d-inline">
        <svg class="first-circle" width="17" height="17" viewBox="0 0 17 17" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <circle cx="8.5" cy="8.5" r="8" fill="white" stroke="#272529"/>
        </svg>
        <svg class="line" width="1" height="23" viewBox="0 0 1 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="0.5" y1="-2.18557e-08" x2="0.500001" y2="23" stroke="#272529"/>
        </svg>
    </div>
</template>
<style>

</style>
